import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { defineAsyncComponent, markRaw, computed } from "vue";
import { storeToRefs } from "pinia";
import { useLoyaltySticker } from "./use-loyalty-sticker";


export default /*@__PURE__*/_defineComponent({
  __name: '_sticker-wrapper',
  setup(__props) {

const { stickerType, stickerSubtype } = storeToRefs(useLoyaltySticker());

const selectedStickerComponent = computed(() => {
    switch (stickerType.value) {
        case "Anonymous":
            return markRaw(
                defineAsyncComponent(
                    () => import("@/loyalty/components/loyalty-sticker/stickers/anonymous-sticker.vue")
                )
            );
        case "Bonusomat":
            return markRaw(
                defineAsyncComponent(() => import("@/casino/bonusomat/components/sticker/bonusomat-sticker.vue"))
            );
        case "GoldenWheel":
            return markRaw(defineAsyncComponent(() => import("@/golden-wheel/components/gw-sticker.vue")));

        case "FurrySpin":
            return markRaw(defineAsyncComponent(() => import("@/furry-spin/components/fs-sticker.vue")));

        default:
            return null;
    }
});

return (_ctx: any,_cache: any) => {
  return (selectedStickerComponent.value)
    ? (_openBlock(), _createBlock(_resolveDynamicComponent(selectedStickerComponent.value), {
        key: 0,
        "anonymous-type": _unref(stickerSubtype)
      }, null, 8, ["anonymous-type"]))
    : _createCommentVNode("", true)
}
}

})